import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import MainContainer from "../../components/container/MainContainer";
import { getNations } from "../../features/nationsSlice";
import Table from "../../components/tables/Table";
import { useLocation } from "react-router-dom";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import LocationHeader from "../../components/header/LocationHeader";
import PaginationSecondBar from "../../components/pagination/PaginationSecondBar";
import AddNation from "./AddNation";
import { openModal } from "../../features/modalSLice";
import { useAuthorization } from "../../hooks/useAuthorization";
import Modal from "../../components/modal/Modal";

const Nation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const nations = useSelector((state) => state.nations.data);
  const loading = useSelector((state) => state.nations.load.getNations);
  const total = useSelector((state) => state.nations.total);
  const { isAuthorized } = useAuthorization();

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Nation" },
    { id: "type", text: "Type" },
    { id: "email", text: "email" },
    { id: "country", text: "Country" },
    // { id: "action", text: "Actions" },
  ];

  const onPageChange = async (limit, offset) => {
    try {
      await dispatch(getNations({ limit, offset }));
    } catch (error) {}
  };

  const openNationModal = () => {
    dispatch(openModal(<AddNation />));
  };

  useEffect(() => {
    dispatch(getNations());
  }, []);

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer className={`text-text-1`}>
      <Modal>{modalContent}</Modal>
      <LocationHeader
        title="Countries (Antenna)"
        links={[]}
        action={openNationModal}
        authorized={isAuthorized("countries", "create")}
      />
      {/* <PaginationSecondBar
        loading={loading}
        onPageChange={onPageChange}
        total={total}
      /> */}
      <main className="table-container">
        {nations instanceof Array && (
          <Table columns={columns} data={nations} link />
        )}
      </main>
    </MainContainer>
  );
};

export default Nation;
